// @flow
import React, { useState } from 'react';
import cx from 'classnames';

import * as styles from './HeaderMobile.module.scss';

const LinkBox = ({
  to,
  text,
  children,
  activeSubMenu,
}: {
  to: string,
  text: string,
  children: React$Node,
  activeSubMenu?: boolean,
}) => {
  const [isActive, setIsActive] = useState(false);

  const onToggle = event => {
    event.preventDefault();

    setIsActive(!isActive);
  };

  return (
    <div className={cx(styles.linkBox, isActive ? styles.isActive : '')}>
      <button
        className={cx(styles.toggle, 'a11y', isActive ? styles.isActive : '')}
        onClick={onToggle}
      >
        Toggle
      </button>
      <a href={to} onClick={onToggle} className={cx(activeSubMenu ? styles.active : '')}>
        {text}
      </a>
      {children}
    </div>
  );
};

LinkBox.defaultProps = {
  activeSubMenu: false,
};

export default LinkBox;
